var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.67,
    height: 25.67,
    viewBox: "0 0 25.67 25.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_arrow-down",
    "data-name": "vuesax/outline/arrow-down",
    transform: "matrix(-0.574, -0.819, 0.819, -0.574, 10.572, 25.67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-down",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.236,5.812a.57.57,0,0,1-.407-.169L.167.981A.576.576,0,0,1,.981.167L5.236,4.422,9.49.167A.576.576,0,0,1,10.3.981L5.643,5.643A.57.57,0,0,1,5.236,5.812Z",
    transform: "translate(3.98 10.508)",
    fill: "#0098da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M.576,14.077A.58.58,0,0,1,0,13.5V.576A.58.58,0,0,1,.576,0a.58.58,0,0,1,.576.576V13.5A.58.58,0,0,1,.576,14.077Z",
    transform: "translate(8.64 2.112)",
    fill: "#0098da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H18.432V18.432H0Z",
    transform: "translate(0)",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkArrow);
export default __webpack_public_path__ + "static/media/link-arrow.dcaa0c02b137aa6fd9d90257ac29f41e.svg";
export { ForwardRef as ReactComponent };